export const BELOW_MINIMUM_MARGIN_MESSAGE =
  'A proposta está abaixo da margem mínima configurada.';

export const BELOW_MINIMUM_MARGIN_CONFIRM_MESSAGE =
  'A proposta está abaixo da margem mínima configurada. Deseja aceitar mesmo assim?';

export function getProposalMargin(
  proposalValue: number,
  costPrice: number | null | undefined
): number | undefined {
  if (costPrice != null && costPrice > 0) {
    return proposalValue / costPrice - 1;
  }
  return undefined;
}

export function isBelowMinimumMargin(
  proposalValue: number,
  costPrice: number | null | undefined,
  minimumMargin: number | null | undefined
): boolean {
  if (minimumMargin == null) {
    return false;
  }
  const margin = getProposalMargin(proposalValue, costPrice);
  if (margin == null) {
    return false;
  }
  return margin < minimumMargin;
}

export function formatMarginPercent(decimal: number | null | undefined): string {
  if (decimal == null) return '-';
  return `${(decimal * 100).toFixed(1).replace('.', ',')}%`;
}

export function formatTolerancePp(decimal: number | null | undefined): string {
  if (decimal == null) return 'Sem limite';
  return `${(decimal * 100).toFixed(1).replace('.', ',')} p.p.`;
}

export function marginPercentInputToDecimal(
  percent: number | null | undefined | string
): number | null {
  if (percent === null || percent === undefined || percent === '') {
    return null;
  }
  const value =
    typeof percent === 'string'
      ? Number(String(percent).replace(',', '.'))
      : percent;
  if (value == null || Number.isNaN(value)) {
    return null;
  }
  const roundedPercent = Math.round(value * 10) / 10;
  return roundedPercent / 100;
}

export function tolerancePpInputToDecimal(raw: string | null | undefined): number | null {
  if (raw === null || raw === undefined || String(raw).trim() === '') {
    return null;
  }
  const normalized = String(raw).replace(/%/g, '').replace(/\s/g, '').replace(',', '.');
  if (normalized === '' || normalized === '-') {
    return null;
  }
  const n = parseFloat(normalized);
  if (Number.isNaN(n)) {
    return null;
  }
  return Math.round(n * 10) / 10 / 100;
}

export function decimalToTolerancePpInput(decimal: number | null | undefined): string {
  if (decimal == null) {
    return '';
  }
  return (decimal * 100).toFixed(1).replace('.', ',');
}

export function isBelowUserMarginLimit(
  proposalValue: number,
  costPrice: number | null | undefined,
  minimumProposalAcceptanceMargin: number | null | undefined,
  effectiveLimit: number | null | undefined,
  canAcceptBelowMinimumMargin = false
): boolean {
  if (minimumProposalAcceptanceMargin == null) {
    return false;
  }
  const margin = getProposalMargin(proposalValue, costPrice);
  if (margin == null) {
    return false;
  }
  if (effectiveLimit != null) {
    return margin < effectiveLimit;
  }
  if (canAcceptBelowMinimumMargin) {
    return false;
  }
  return margin < minimumProposalAcceptanceMargin;
}

export function computeEffectiveLimitPreview(minimumMargin: number | null, toleranceDecimal: number | null): number | null {
  if (toleranceDecimal == null || minimumMargin == null) return null;
  return minimumMargin - toleranceDecimal;
} 

export function belowMinimumMarginMessage(effectiveMarginLimit?: number | null): string {
  if (effectiveMarginLimit != null) {
    return `A margem está abaixo do limite do seu perfil (${formatMarginPercent(effectiveMarginLimit)}).`;
  }
  return BELOW_MINIMUM_MARGIN_MESSAGE;
}